<template>
  <div class="relative">
    <!-- <modal
      :show.sync="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class=" overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center  pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              @click="editModal = false"
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </modal> -->
    <swiper-slide class="sm-h600">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="lg:flex md:flex">
        <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="
            min-hidden
            w-80per
            absolute
            top-0
            right-0
            line-bgh-525px
            z-index--1
          "
        />
        <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
          <div
            class="
              lg:w-5/6
              md:w-5/6
              ml-auto
              lg:pt-0
              md:pt-0
              pt-20
              lg:px-0
              md:px-0
              px-6
            "
          >
            <p
              class="
                font-semibold
                fsize48
                sm-fsize24
                line-h60
                letter-s016px
                text-black
                leading-snug
                lg:w-full
                md:w-full
                w-5/6
              "
            >
              Presentation
            </p>

            <p
              class="
                lg:text-2xl
                md:text-2xl
                sm-fsize14
                font-normal
                lg:pt-6
                md:pt-6
                pt-3
                lh40px
                sm-lh20
              "
            ></p>
          </div>
        </div>

        <div class="lg:w-1/2 md:w-1/2 w-full relative">
          <img
            src="../../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="mob-hidden w-full relative h-95per bg-white"
          />
          <img
            src="../../../../assets/images/swiper-img/inst-pres-bg-mob.svg"
            class="
              w-full
              absolute
              min-top8rem min-h-86per
              mt-4
              block
              lg:hidden
              md:hidden
            "
            alt=""
          />
          <img
            src="../../../../assets/images/swiper-img/swpr-insi-pres.svg"
            class="w-full absolute top6rem h-screen md:block lg:block hidden"
            alt=""
          />
        </div>
      </div>
    </swiper-slide>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
      },
      editModal: false,
    };
  },
};
</script>
